import { createSelector } from "reselect";

const selectOnlineExam = (state) => state.onlineExam;

export const selectExamOnlineOffset = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.offset
);
export const selectExamOnlineLoadMore = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.loadMore
);

export const selectOnlineExamData = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.onlineExamData
);

export const selectIsFetchingExams = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.isFetchingExams
);

export const selectExamMode = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.examMode
);
export const selectIsUploadingFile = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.isUploadingFile
);

export const selectErrorFetchingExams = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.errorFetchingExams
);

///select examDetail By ID
export const selectOnlineExamDetailData = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.onlineExamDetailData
);

export const selectIsFetchingExamDetail = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.isFetchingExamDetail
);

export const selectErrorFetchingExamDetail = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.errorFetchingExamDetail
);

export const selectExamCounter = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.counter
);
export const selectCurrentQuestionIndex = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.currentQuestionIndex
);

///select exam Result By ID
export const selectOnlineExamResultData = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.onlineExamResultData
);

export const selectIsFetchingExamResult = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.isFetchingExamResult
);
export const selectFetchingExamWarning = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.onlineExamResultWarning
);

export const selectErrorFetchingExamResult = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.errorFetchingExamResult
);
///select exam Answer By ID
export const selectOnlineExamAnswerData = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.onlineExamAnswerData
);

export const selectIsFetchingExamAnswer = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.isFetchingExamAnswer
);

export const selectErrorFetchingExamAnswer = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.errorFetchingExamAnswer
);
///select Post Exam

export const selectIsFetchingPostExam = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.isFetchingPostExam
);

export const selectErrorFetchingPostExam = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.errorFetchingPostExam
);
//GetResults
export const selectResultsOffset = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.resultOffset
);
export const selectResultLoadMore = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.resultLoadMore
);

export const selectResultData = createSelector(
  [selectOnlineExam],
  (exams) =>  exams&&exams.resultData
);

export const selectIsFetchingResults = createSelector(
  [selectOnlineExam],
  (exams) => exams&&exams.isFetchingResults
);

export const selectErrorFetchingResults = createSelector(
  [selectOnlineExam],
  (exams) => exams&& exams.errorFetchingResults
);

export const selectShowNextQuestion = createSelector(
  [selectOnlineExam],
  (exams) =>exams &&  exams.showNextQuestion
);


//current Page

export const selectCurrentPage = createSelector(
  [selectOnlineExam],
  (exams) =>exams && exams.currentPage
);
